import * as React from 'react';

export const setDisplayName = <T extends React.FC>(displayName: string, component: T) => {
  component.displayName = displayName;
  return component;
};
